/*
 * The changed regex used in this validator matches on one-or-many occurences of the last
 * matching group instead of zero-or-many occurences
 * - old: [...] -Z0-9])?)*$/
 * - new: [...] -Z0-9])?)+$/
 * which therefore always includes the last matching group which always starts with a [dot].
 *
 * This validator also accepts umlauts in second-level domains.
 *
 * It does not match addresses starting with a dot, containing consecutive dots or a dot
 * before the @-character.
 */
export const emailPattern = new RegExp(
  // tslint:disable-next-line: max-line-length
  /^(?!\.)([a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]|(\.(?![.@])))+@[a-zA-Z0-9\u00c4\u00e4\u00d6\u00f6\u00dc\u00fc](?:[a-zA-Z0-9-\u00c4\u00e4\u00d6\u00f6\u00dc\u00fc]{0,61}[a-zA-Z0-9\u00c4\u00e4\u00d6\u00f6\u00dc\u00fc])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/
);

/**
 * Validates an email using a regex pattern taken from:
 * https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
 *
 * This is in most parts the same regex Angulars 'Validators.email' uses, but with a
 * small change.
 *
 * The original regex pattern allows for addresses that do not end with [dot]domain.
 * So the following email addresses would be considered valid by the validator:
 * - mail@example-com
 * - mail@example
 *
 * Instead we want the email address to always end with a [dot]domain like:
 * - mail@example.com
 *
 * @param control FormControl
 */
export function validateEmail(control: { value: string }): { [key: string]: any } | null {
  if (control.value) {
    const isValidEmail = emailPattern.test(control.value);
    return isValidEmail ? null : { validateEmail: { valid: false } };
  }
  return null;
}
